import styled from 'styled-components';
import color from '@decisiv/design-tokens/lib/color';
import spacing from '@decisiv/design-tokens/lib/spacing';
import toColorString from 'polished/lib/color/toColorString';
import rem from 'polished/lib/helpers/rem';
import Flex from '@decisiv/ui-components/lib/components/Flex';

export const HIGHLIGHT_COLOR = toColorString(color.status.information.light);

export const TableWrapper = styled.div`
  td:has([data-highlighted-cell]) {
    background-color: ${HIGHLIGHT_COLOR} !important;
  }
`;

export default TableWrapper;

export const FullWidthRow = styled(Flex)`
  width: 100%;
`;

// KDS ghost buttons sit slightly high next to a line of table text.
export const CopyButtonWrap = styled.span`
  button {
    padding-bottom: ${rem(spacing.base * 0.5)};
    padding-left: ${rem(spacing.base * 0.5)};
  }
`;
